
    <div *ngIf="toast.data">
      <div *ngFor='let item of toast.data.details'>
        {{item.field}}: <br/>
        <span *ngFor='let error of item.errors'>{{error}}</span><br/>
      </div>
    </div>
  